import { render, staticRenderFns } from "./challenge_list.vue?vue&type=template&id=32934931&scoped=true"
import script from "./challenge_list.vue?vue&type=script&lang=js"
export * from "./challenge_list.vue?vue&type=script&lang=js"
import style0 from "./challenge_list.vue?vue&type=style&index=0&id=32934931&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32934931",
  null
  
)

export default component.exports